module.exports = __webpack_public_path__ + "images/083c787b38c399cbc6301a09e6259d14-logo.png";